module.exports = __webpack_public_path__ + "static/media/11@1920w.ba28d0ea.jpg";